import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { FullExtentNotifier } from './full-extent-notifier';
import { FullExtentState } from './full-extent-state';

@Injectable()
export class FullExtentProvider extends BaseProvider<FullExtentNotifier, FullExtentState> {
  constructor() {
    super(FullExtentNotifier);
  }
}
